import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/articles/terms-and-condition.tsx");
